import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';

const Logo = ({ modifier }) => (
  <Link href="/" className={['logo-wrapper', modifier].join(' ')}>
    <img src="/static/img/dockwalk-logo.png" alt="Dockwalk logo" className="logo" />
  </Link>
);

Logo.propTypes = {
  modifier: PropTypes.string
};

Logo.defaultProps = {
  modifier: ''
};

export default Logo;
